import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { CheckIn } from '../../../schemas/check-in';
import { TimePeriod } from '../components/check-ins-over-time/types';

export function useCheckInsOverTime(meetingId: string, period: TimePeriod = '12w') {
	const http = useHttpClient();

	return useQuery<CheckIn[], Error>({
		queryKey: ['check-ins-over-time', meetingId, period],
		queryFn: async () => {
			const res = await http.get<CheckIn[]>(`/one_on_ones/meetings/${meetingId}/check_ins`, {
				params: { period },
				headers: {
					'Key-Inflection': 'camel',
				},
			});
			return res.data;
		},
		enabled: !!meetingId,
		refetchOnWindowFocus: false,
		staleTime: 5 * 60 * 1000, // 5 minutes
	});
}
